import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from 'vue'
import { showToastLoading } from '@/utils/tools'
import { setDocumentTitle } from '@/utils/dom'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'customer-service',
  setup(__props) {

const $route = useRoute()
setDocumentTitle('极小美')
showToastLoading()
const visitorId = ($route.query.visitorId as string) || ($route.query.visitorld as string)
const url = `https://webchat-bj.clink.cn/chat.html?accessId=8ca9ac7f-e63e-43b5-9e13-a204d135e6b7&language=zh_CN&headerDisplay=0&visitorId=${visitorId}`
window.location.replace(url)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})